import { Routes } from '@angular/router';
import { LandingComponent } from './pages/landing/landing.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OtpScreenComponent } from './pages/otp-screen/otp-screen.component';
import { OnboardingComponent } from './pages/onboarding/onboarding.component';
import { ImportEmployeesComponent } from './pages/import-employees/import-employees.component';
import { GetQuoteFormComponent } from './pages/company-form/get-quote-form.component';
import { EmployeeDetailsComponent } from './pages/employee-details/employee-details.component';
import { QuotationsComponent } from './pages/quotations/quotations.component';
import { dashboardGuard } from './shared/services/guard/dashboard.guard';
import { landingGuard } from './shared/services/guard/landing.guard';
import { HealthDeclarationComponent } from './pages/health-declaration/health-declaration.component';
import { MyCompaniesComponent } from './dashboard/my-companies/my-companies.component';
import { PurchasedPoliciesComponent } from './dashboard/purchased-policies/purchased-policies.component';
import { CancellationRequestsComponent } from './dashboard/cancellation-requests/cancellation-requests.component';
import { ActiveQuotesComponent } from './dashboard/active-quotes/active-quotes.component';
import { PaymentReceiptsComponent } from './dashboard/payment-receipts/payment-receipts.component';
import { SettingsComponent } from './dashboard/settings/settings.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { HomeComponent } from './dashboard/home/home.component';
import { CompanyFormComponent } from './dashboard/my-companies/company-form/company-form.component';
import { PolicyDetailsComponent } from './components/policy-details/policy-details.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
import { FaqComponent } from './pages/faq/faq.component';

export const routes: Routes = [
  { path: '', component: LandingComponent, data: { title: '' } },
  { path: 'about', component: AboutComponent, data: { title: '' } },
  { path: 'contact', component: ContactComponent, data: { title: '' } },
  { path: 'faq', component: FaqComponent, data: { title: '' } },
  {
    path: 'onboarding',
    component: OnboardingComponent,
    data: { title: 'Onboarding' },
  },
  {
    path: 'verify-otp',
    component: OtpScreenComponent,
    data: { title: 'Verify OTP' },
  },
  {
    path: 'import-employees',
    component: ImportEmployeesComponent,
    data: {
      title: 'NAV.PURCHASED_POLICIES',
      subtitle: 'NAV.COMPLETE_INSURANCE_APPLICATION',
    },
  },
  {
    path: 'company-details',
    component: GetQuoteFormComponent,
    data: {
      title: 'NAV.PURCHASED_POLICIES',
      subtitle: 'NAV.COMPLETE_INSURANCE_APPLICATION',
    },
  },
  {
    path: 'employee-details',
    component: EmployeeDetailsComponent,
    data: { title: 'EMPLOYEE_DETAILS.TITLE' },
  },
  {
    path: 'employee-details/active',
    component: EmployeeDetailsComponent,
    data: { isActive: true, title: 'EMPLOYEE_DETAILS.TITLE' },
  },
  {
    path: 'quotations',
    component: QuotationsComponent,
    data: { title: 'QUOTATIONS.TITLE' },
  },
  {
    path: 'health-declaration',
    component: HealthDeclarationComponent,
    data: {
      title: 'NAV.PURCHASED_POLICIES',
      subtitle: 'NAV.COMPLETE_INSURANCE_APPLICATION',
    },
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./dashboard/dashboard.component').then(
        (c) => c.DashboardComponent
      ),
    canActivate: [dashboardGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'home',
        component: HomeComponent,
        data: { title: 'NAV.DASHBOARD' },
      },
      {
        path: 'active-quotes',
        component: ActiveQuotesComponent,
        data: { title: 'NAV.ACTIVE_QUOTES' },
      },
      {
        path: 'companies',
        component: MyCompaniesComponent,
        data: { title: 'NAV.MY_COMPANIES' },
      },
      {
        path: 'policies',
        component: PurchasedPoliciesComponent,
        data: { title: 'NAV.PURCHASED_POLICIES' },
      },
      {
        path: 'settings',
        component: SettingsComponent,
        data: { title: 'NAV.SETTINGS' },
      },
      {
        path: 'renew-policy',
        component: PurchasedPoliciesComponent,
        data: { title: 'NAV.RENEW_MY_POLICY' },
      },
      {
        path: 'cancellations',
        component: CancellationRequestsComponent,
        data: { title: 'DASHBOARD.POLICIES.CANCELLED_POLICIES' },
      },
      {
        path: 'import-employees',
        component: ImportEmployeesComponent,
        data: { title: 'IMPORT_EMPLOYEES.TITLE' },
      },
      {
        path: 'employee-details',
        component: EmployeeDetailsComponent,
        data: { title: 'EMPLOYEE_DETAILS.TITLE' },
      },
      {
        path: 'invoices',
        component: PaymentReceiptsComponent,
        data: { title: 'NAV.INVOICES' },
      },
      {
        path: 'companies/form',
        component: CompanyFormComponent,
        data: { title: 'DASHBOARD.MY_COMPANIES.ADD_COMPANY' },
      },
      {
        path: 'companies/form/:id',
        component: CompanyFormComponent,
        data: { title: 'DASHBOARD.MY_COMPANIES.ADD_COMPANY' },
      },
      {
        path: 'policy-details/:id',
        component: PolicyDetailsComponent,
        data: { title: 'DASHBOARD.POLICIES.POLICY_DETAILS.TITLE' },
      },
    ],
  },
  {
    path: 'payment',
    component: PaymentComponent,
    canActivate: [dashboardGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    data: { title: 'PAYMENT.TITLE' },
  },
  { path: '**', redirectTo: '' },
];
